import axios from "axios";
import { IResolucion } from "constants/interfaces/resolucion.interface";
import { getAuthToken } from "helpers/Auth";

/**
 * Método que obtiene la id de la última resolucion vigente.
 *
 * @returns {Promise<IResolucion>} Id de la última resolución vigente.
 */
export const getResoluciones = async (tipo?: string): Promise<IResolucion[]> => {
  try {
    const query = tipo ? `?TipoResolucion=${tipo}` : '';
    const response = await axios.get(
      `${process.env.REACT_APP_GCR_URL}/Resoluciones/ListarResoluciones${query}`,
      {
        headers: {
          "x-api-key": `Basic ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Método para obtener las resoluciones por su respectiva id.
 *
 * @param {string} id Id de la resolución.
 * @returns {Promise<BlobPart>} archivo blob de la resolución.
 */
export const descargarResolucionById = async (
  id: string
): Promise<BlobPart> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GCR_URL}/Resoluciones/DescargarResolucion?IdResolucion=${id}`,
      {
        responseType: "blob",
        headers: {
          "x-api-key": `Basic ${getAuthToken()}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
